import { render, staticRenderFns } from "./GenusIndexEditComponent.vue?vue&type=template&id=60316a6d&scoped=true&"
import script from "./GenusIndexEditComponent.vue?vue&type=script&lang=js&"
export * from "./GenusIndexEditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60316a6d",
  null
  
)

export default component.exports